import { createSlice } from "@reduxjs/toolkit";
import {
  addCustomer,
  fetchCustomer,
  fetchCustomerById,
  updateCustomer,
  updateStatusInCustomer,
} from "./thunk";

interface CategoryState {
  customerList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  customerList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "customer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.customerList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchCustomer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Customers";
      })
      .addCase(fetchCustomerById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchCustomerById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addCustomer.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.customerList = state.customerList.map((category) =>
          category.id === action.payload.id ? action.payload : category
        );
      })
      .addCase(addCustomer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update Customer";
      })
      .addCase(updateCustomer.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.customerList = state.customerList.map((category) =>
          category.id === action.payload.id ? action.payload : category
        );
      })
      .addCase(updateCustomer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update Customer";
      })
      .addCase(updateStatusInCustomer.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInCustomer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
